

import { Link } from "react-router-dom"
import "./Disclaimer.css"

const Disclaimer = () => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })

  return (
    <div className="disclaimer-container">
      <div className="disclaimer-header">
        <div className="logo-container">
          <img src="/logo.png" alt="Swear Vault Logo" className="disclaimer-logo animated-logo" />
        </div>
        <h1>Disclaimer & Legal Notice</h1>
        <div className="disclaimer-subtitle">
          <a href="https://swearvault.com" target="_blank" rel="noopener noreferrer">
            swearvault.com
          </a>
        </div>
      </div>

      <div className="disclaimer-content">
        <p className="effective-date">Effective Date: May 6, 2025</p>

        <p className="disclaimer-intro">
          SwearVault.com ("we", "our", "us") is a research-driven platform dedicated to collecting, classifying, and
          analyzing offensive, profane, and culturally sensitive words in global languages and dialects. The sole
          purpose of this initiative is to support the development of AI models for responsible speech recognition and
          content moderation.
        </p>

        <section className="disclaimer-section">
          <h2>Purpose of Collection</h2>
          <div className="section-content">
            <p>The platform collects linguistic data for:</p>
            <ul>
              <li>• Training AI models for audio fingerprinting and voice moderation.</li>
              <li>• Enhancing natural language understanding for regional global languages.</li>
              <li>
                • Supporting research into hate speech detection, profanity filtering, and context-aware audio
                analytics.
              </li>
            </ul>
            <p>
              This collection is conducted strictly for research, security, and moderation purposes. We do not promote,
              glorify, or endorse any kind of abusive or offensive language.
            </p>
          </div>
        </section>

        <section className="disclaimer-section">
          <h2>Legal & Ethical Compliance</h2>
          <div className="section-content">
            <h3>Academic and Technological Use Only</h3>
            <p>
              This initiative is carried out under the principles of academic freedom, data ethics, and technological
              advancement. No data is used for public viewing, entertainment, or discrimination.
            </p>

            <h3>No Public Browsing or Display</h3>
            <p>
              The collected data is not visible to the public and cannot be browsed, searched, or accessed through the
              website or any user interface.
            </p>

            <h3>Voluntary Contribution & Anonymity</h3>
            <ul>
              <li>• Data contributions are voluntary and anonymous.</li>
              <li>• No personally identifiable information (PII) is stored or associated with submitted content.</li>
              <li>• The system is built to ensure privacy by design.</li>
            </ul>

            <h3>No Offensive Display</h3>
            <p>
              Users cannot see or interact with any of the submitted content. The dataset is strictly stored for offline
              research and model training purposes only.
            </p>
          </div>
        </section>

        <section className="disclaimer-section">
          <h2>Prohibited Submissions</h2>
          <div className="section-content">
            <p>
              Do not submit content that promotes hate speech, violence, harassment, or threats against individuals,
              communities, or religious/cultural groups.
            </p>
            <p>
              Submissions meant to spread communal disharmony or illegal speech will be logged and may be reported to
              relevant authorities.
            </p>
          </div>
        </section>

        <section className="disclaimer-section">
          <h2>Use of Data and AI Models</h2>
          <div className="section-content">
            <p>
              The dataset is used for training speech moderation tools, voice-based abuse detection, and AI models to
              identify sensitive content in spoken media.
            </p>
          </div>
        </section>

        <section className="disclaimer-section">
          <h2>Ethical Assurance</h2>
          <div className="section-content">
            <p>We follow strict guidelines to:</p>
            <ul>
              <li>• Maintain linguistic neutrality.</li>
              <li>• Avoid biases against any language, region, caste, or community.</li>
              <li>• Build AI that helps protect online and offline communication spaces.</li>
            </ul>
          </div>
        </section>

        <section className="disclaimer-section">
          <h2>Contact Us</h2>
          <div className="section-content">
            <p>For legal concerns, ethical queries, or compliance questions, please write to:</p>
            <p className="contact-details">
              <a href="mailto:contact@swearvault.com">contact@swearvault.com</a>
              <br />
              <a href="https://swearvault.com" target="_blank" rel="noopener noreferrer">
                swearvault.com
              </a>
            </p>
          </div>
        </section>

        <section className="disclaimer-section">
          <h2>Acknowledgment</h2>
          <div className="section-content">
            <p>By submitting content to this platform, users acknowledge and agree that:</p>
            <ul>
              <li>• The data is collected for non-public, research-based use.</li>
              <li>• The project supports ethical AI development and inclusive linguistic understanding.</li>
              <li>• No data submitted will be publicly accessible or displayed.</li>
            </ul>
          </div>
        </section>

        <div className="back-link">
          <Link to="/">Back to Home</Link>
        </div>
      </div>
    </div>
  )
}

export default Disclaimer
